module.exports = __webpack_public_path__ + "static/img/100824.9feee6cb.png";